import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@mui/material';

const MoreActionDropdown = ({ actions, onClick, onClose, containerClasses, buttonClasses }) => {
    const dropdownRef = useRef(null);

    useEffect(() => {
        const dropdownEl = dropdownRef.current;
        if (!dropdownEl) return;

        const buttons = dropdownEl.querySelectorAll('button');
        const handlers = [];

        buttons.forEach((button, index) => {
            const actionKey = actions[index].key;

            const clickHandler = e => {
                e.preventDefault();
                e.stopPropagation();
                onClose();

                setTimeout(() => {
                    onClick(actionKey);
                }, 100);
            };

            handlers.push({ element: button, handler: clickHandler });

            button.addEventListener('click', clickHandler);
            button.addEventListener('touchend', clickHandler); // For mobile
        });

        return () => {
            handlers.forEach(({ element, handler }) => {
                if (element) {
                    element.removeEventListener('click', handler);
                    element.removeEventListener('touchend', handler);
                }
            });
        };
    }, [actions, onClick, onClose]);

    return (
        <div ref={dropdownRef} className={containerClasses} role="menu">
            {actions.map(({ key, label, icon }, index) => (
                <div key={key} className="w-full">
                    <button
                        className={`${buttonClasses}  w-full !p-3`}
                        role="menuitem"
                        type="button"
                        data-action-key={key}>
                        {label?.toUpperCase()}
                    </button>
                    {index < actions.length - 1 && <Divider className=" !bg-divider-text" />}
                </div>
            ))}
        </div>
    );
};

MoreActionDropdown.propTypes = {
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            icon: PropTypes.node,
        }),
    ).isRequired,

    onClick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,

    containerClasses: PropTypes.string,
    buttonClasses: PropTypes.string,
};

export default MoreActionDropdown;
